export const ABLE_STORE = 'ableapp-com';
